import React from "react"
import { Audio } from "@components/sections"
import styles from "./audioContent.module.scss"

const AudioContent = ({ data }) => {
  const { anchorUrl } = data
  return <Audio url={anchorUrl} className={styles.container} />
}

export default AudioContent
